<template>
  <div id="doctorListF">
    <div style="padding:30px;width:1200px;margin:0 auto">
      <breadcrumb msg="专家介绍" msg1="专家简介"></breadcrumb>
      <div id="doctorListName">
        <div id="picture">
          <img src="../assets/img/s5dbfc85a93c43.jpg" alt srcset />
        </div>
        <div id="intro">
          <div id="doctorName">刘红旭</div>
          <div id="doctorPost">「 主任医师 」</div>
          <div id="doctorSpeciality">
            <img src="../assets/img/bar9.png" alt />
            <span>专长</span>
          </div>
          <div>冠心病心绞痛、心力衰竭、心律失常、高血压 、糖脂代谢紊乱</div>
          <div id="doctorSpeciality">
            <img src="../assets/img/bar9.png" alt />
            <span>导师资格</span>
          </div>
          <div>首都医科大学博士研究生导师、北京中医药大学博士研究生导师</div>
          <div id="doctorSpeciality">
            <img src="../assets/img/bar9.png" alt /> 医事服务费
          </div>
          <div>专家门诊100元</div>
        </div>
      </div>
      <div id="doctorBody" style="margin-top:50px">
        <div style="font-size:22px">
          <img style="margin-right:15px" src="../assets/img/arr2.png" alt srcset />简介
        </div>
        <p>刘红旭，男，现任首都医科大学附属北京中医医院首席专家，心血管科主任，心血管病研究室主任，主任医师，教授，博士研究生导师。</p>
        <p>从事中医、中西医结合心血管病及危重病的临床、教学及科研工作30余年。历任北京中医医院急诊科主任，心血管科主任、心血管病研究室主任、内科教研室主任；北京市中医研究所临床流行病学研究室主任、中医心血管病研究室主任。</p>
        <p>卫生部国家中医心血管病重点专科、国家中医药管理局中医心血管病重点学科、重点专科，北京市中医心血管重点学科、重点专科的学术带头人，北京市中医125人才1类（学术带头人），北京市卫生系统215高层次人才（学科带头人），北京市“十百千”卫生人才十层次杰出人才。</p>
      </div>
      <div id="doctorDetail">
        <div style="font-size:22px">
          <img style="margin-right:15px" src="../assets/img/arr2.png" alt srcset />科室信息
        </div>
        <div id="doctorDetailBody">
            <div id="doctorDetailBodyImg">
                <img src="../assets/img/s5e0866a322355.jpg" alt="">
            </div>
            <div id="doctorDetailBodyText">
                <div>心血管科</div>
                <p>首都医科大学附属北京中医医院心血管科成立于北京中医医院建院初期，发展近60载，目前是卫生部国家中医心血管病重点专科、国家中医药管理局心血管病重点学科/重点专科、北京市中医管理局心血管病重点学科/重点专科、北京市医院管理局重点医学专业、北京市国家中医重点专科辐射工程首都核心专科、燕京流派创新性传承“拳头”工程、以及北京市中医心血管病防治办公室承担单位。拥有许心如、魏执真、黄丽娟三名国家级名老中医及国家中医药管理局名医工作室站以及许公岩名医研究室。</p>
            </div>
        </div>
      </div>
    </div>
  </div>
</template>
<script>
import breadcrumb from "../components/breadcrumb1";
export default {
  components: { breadcrumb }
};
</script>
<style lang="less" scoped>
#doctorListName {
  width: 100%;
  height: 400px;
  display: flex;
  flex-direction: row;
  margin-top: 40px;
  background-image: url(../assets/img/ysxqy1.png);
  background-size: 100% 100%;
  color: #ffffff;
  #picture {
    width: 300px;
    height: 100%;
    img {
      width: 100%;
      height: 100%;
    }
  }
  #intro {
    flex-grow: 2;
    padding: 40px 50px;
    font-size: 14px;
    div {
      margin: 15px 0;
    }
    #doctorName {
      font-size: 20px;
      font-weight: 600;
    }
    #doctorPost {
      font-size: 16px;
    }
    #doctorSpeciality {
      font-size: 18px;
      img {
        width: 15px;
        height: 15px;
      }
    }
  }
}
#doctorBody {
  p {
    text-indent: 2em;
    font-size: 14px;
  }
}
#doctorDetail {
  width: 100%;
  height: 400px;
  margin-top: 40px;
  color: black;
  #doctorDetailBody{
      display: flex;
      flex-direction: row;
      #doctorDetailBodyImg{
          width: 380px;
          padding: 30px;
      }
      #doctorDetailBodyText{
          padding: 40px 50px;
          div{
              font-size: 24px;
          }
          p{
              font-size: 14px;
          }
      }
  }
}
</style>
<style lang="less">
#doctorListF {
  background-image: url(../assets/img/czys1.jpg);
  /deep/ #address {
    color: rgb(69,109,171) ;
  }
  /deep/ .el-breadcrumb__inner a,
  .el-breadcrumb__inner,
  .el-breadcrumb__inner.is-link {
    color: rgb(69,109,171)  !important;
  }
  /deep/ .el-breadcrumb__item:last-child .el-breadcrumb__inner,
  .el-breadcrumb__item:last-child .el-breadcrumb__inner a,
  .el-breadcrumb__item:last-child .el-breadcrumb__inner a:hover,
  .el-breadcrumb__item:last-child .el-breadcrumb__inner:hover {
    color: rgb(69,109,171)  !important;
    font-weight: 600 !important;
  }
  /deep/ .el-breadcrumb__separator {
    color: rgb(69,109,171)!important;
  }
}
</style>